import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';

import WhatWeOfferItem from './what-we-offer-item/WhatWeOfferItem';
import ProtectionPlanTooltip from './protection-plan-tooltip/ProtectionPlanTooltip';

const whatWeOfferItems = [
  {
    description: 'Installation available on most appliances when you purchase required parts',
    smallTitle: 'Available',
    bigTitle: () => {
      return 'Installation';
    },
    iconName: 'installation',
    iconDescription: 'Appliance Washer Icon',
    linkUrl: '//www.homedepot.com/c/Appliance_Delivery_Installation',
    linkText: 'Installation Requirements',
  },
  {
    description: 'We\'ll move your old appliance to another room in your house, or haul it away for a fee',
    smallTitle: 'Move or',
    bigTitle: () => {
      return 'Haul Away';
    },
    iconName: 'haul-away',
    iconDescription: 'Orange Dolly Icon',
    linkUrl: '',
    linkText: '',
  },
  {
    description: 'We will match prices including shipping of any other online competitor',
    smallTitle: 'Price Match',
    bigTitle: () => {
      return 'Guarantee';
    },
    iconName: 'price-match',
    iconDescription: 'Orange Dollar Sign',
    linkUrl: '//www.homedepot.com/c/PM_New_Lower_Price',
    linkText: 'Learn More',
  },
  {
    description:
      'Get 24/7 support and our 3-day Service Guarantee',
    smallTitle: 'The Home Depot',
    bigTitle: () => {
      return (<div>Protection Plan</div>);
    },
    iconName: 'allstate-protection-plan',
    iconDescription: 'HDPP Allstate Icon',
    linkUrl: 'https://www.homedepot.com/c/Home_Depot_Protection_Plan_Coverage_Details#majorappliances',
    linkText: 'Learn More',
    tooltip: (linkUrl, linkText) => {
      return (<ProtectionPlanTooltip linkUrl={linkUrl} linkText={linkText} />);
    }
  }
];

export const WhatWeOfferContent = () => (
  <Row>
    {whatWeOfferItems.map((item, i) => (
      <Col xs="12" sm="6" md="3" nopadding key={i}>
        <WhatWeOfferItem
          description={item.description}
          smallTitle={item.smallTitle}
          bigTitle={item.bigTitle}
          iconName={item.iconName}
          iconDescription={item.iconDescription}
          linkUrl={item.linkUrl}
          linkText={item.linkText}
          tooltip={item.tooltip}
        />
      </Col>
    ))}
  </Row>
);

WhatWeOfferContent.displayName = 'WhatWeOfferContent';

WhatWeOfferContent.propTypes = {};

WhatWeOfferContent.defaultProps = {};
